import React, { useContext } from 'react'

import type { RecipeGridContentBlock } from '@library/api-menu-experience'
import { RecipeGrid } from '@library/menu-page'

import { MenuBrandingContext } from '../menuBrandingContext'

type RecipeGridContentBlockWrapperProps = {
  contentBlock: RecipeGridContentBlock
}

const onRecipeClick = () => {}
const onAddClick = () => {}
const onRemoveClick = () => {}
const onBlockedAddAttempt = () => {}
const getRecipeTileState = () => ({
  isInBasket: false,
  canAddRecipes: true,
  reachedLimit: false,
})

export const RecipeGridContentBlockWrapper = ({
  contentBlock,
}: RecipeGridContentBlockWrapperProps) => {
  const { textColor } = useContext(MenuBrandingContext)

  return (
    <RecipeGrid
      contentBlock={contentBlock}
      recipeCountTextColor={textColor}
      getRecipeTileState={getRecipeTileState}
      onRecipeClick={onRecipeClick}
      onAddClick={onAddClick}
      onRemoveClick={onRemoveClick}
      onBlockedAddAttempt={onBlockedAddAttempt}
    />
  )
}
